import { useState, useCallback } from 'react';

const useLoading = () => {
    const [loadingStates, setLoadingStates] = useState({});

    const startLoading = useCallback((key) => {
        setLoadingStates(prev => ({
            ...prev,
            [key]: true
        }));
    }, []);

    const stopLoading = useCallback((key) => {
        setLoadingStates(prev => ({
            ...prev,
            [key]: false
        }));
    }, []);

    const isLoading = useCallback((key) => {
        return loadingStates[key] || false;
    }, [loadingStates]);

    const withLoading = useCallback(async (key, asyncFunction) => {
        startLoading(key);
        try {
            const result = await asyncFunction();
            return result;
        } finally {
            stopLoading(key);
        }
    }, [startLoading, stopLoading]);

    return {
        isLoading,
        startLoading,
        stopLoading,
        withLoading
    };
};

export default useLoading;